//Splittingschichten, einstellbar in den Schichtdefinitionen werden geprüft

function checkSplittingShifts(sFehler, iOffset, iWeeks, iAZeitenFT, iRegelPausenWunsch, iArt, sprache){
    var error = "";
    var splittingShift = new Array();
    var splittingShiftDataFromPHP = JSON.parse(document.getElementById("allowedSplittingShifts").innerHTML);
    var splittingShiftFoundForDay = setSplittingShiftFoundForDay(iWeeks);

    if(splittingShiftDataFromPHP.length > 0){
        for(let i = 0; i < splittingShiftDataFromPHP.length; i++){
            let splittingShiftObject = ({
                offset: iOffset
                , weeks: iWeeks
                , ignoreAOnPublicHoliday: iAZeitenFT
                , intervals: splittingShiftDataFromPHP[i]['intervalle']
                , mindestblock: splittingShiftDataFromPHP[i]['mindestblock']
                , minDistance: splittingShiftDataFromPHP[i]['mindestabstand']
                , maxDistance: splittingShiftDataFromPHP[i]['maximalabstand']
                , lastSplittingShiftIndex: splittingShiftDataFromPHP.length-1
                , currentSplittingShiftIndex: i
                , splittingShiftFound: splittingShiftFoundForDay
                , wishBreak: iRegelPausenWunsch
            });
            splittingShift[i] = new SplittingShift(splittingShiftObject);
            splittingShift[i].checkSplitting();
            splittingShiftFoundForDay = splittingShift[i].getSplittingShiftFound();
        }
        error = checkOverAllSplittingShifts(splittingShiftFoundForDay, splittingShift, iWeeks, iArt, sprache);

    }else{
        error = noShiftlimitationsForContract(iOffset, iWeeks, iAZeitenFT, iArt, sprache);
    }

    error = setError(error, sFehler);
    return error ;
}

function setSplittingShiftFoundForDay(iWeeks){
    var splittingShiftFoundForDay = new Array(iWeeks);
    for(let week = 0; week < iWeeks; week ++) {
        splittingShiftFoundForDay[week] = new Array (7);
        for (let day = 0; day < 7; day++) {
            splittingShiftFoundForDay[week][day] = false;
        }
    }
    return splittingShiftFoundForDay;
}

function setError(error, sFehler){
    if(error.length > 0 && sFehler.length > 0){
        error = sFehler + "<br />" + error;
    } else if(error.length > 0 && sFehler.length == 0){
        error = error;
    } else{
        error = sFehler;
    }
    return error;
}

function noShiftlimitationsForContract(iOffset, iWeeks, iAZeitenFT, iArt, sprache){
    let wishWindow = new Array();
    let error = "";
    let weekdays = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
    for(let week = 0; week < iWeeks; week++){
        wishWindow[week] = new WishWeek(iOffset, week+1, iAZeitenFT);
        wishWindow[week].setDays();
        for(var day = 0; day < 7; day++){
            if(wishWindow[week].getNumberOfASegments(day) > 1){
                error = error + "<b>Woche " + (week + 1) + ": " + weekdays[day] + "</b></br>";
                displayErrorPerWeek(error, 0, week+1, iWeeks, iArt, sprache);
            }
        }
    }
    if(error.length > 0){
        error = "Ihrem Vertrag sind keine Splittingschichten zugeordnet.</br></br>" + error;
    }

    return error;
}
function checkOverAllSplittingShifts(splittingShiftFoundForDay, splittingShift, iWeeks, iArt, sprache) {
    let error = "";
    for (let week = 0; week < iWeeks; week++) {
        for (let day = 0; day < 7; day++) {
            if (splittingShiftFoundForDay[week][day] == false) {
                for (let j = 0; j < splittingShift.length; j++) {
                    let temporalError = splittingShift[j].getError(week, day);
                    if (temporalError.length > 0) {
                        error = error + temporalError;
                        displayErrorPerWeek(error, 0, week + 1, iWeeks, iArt, sprache);
                    }
                }
            }
        }
    }
    return error;
}
